function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as t } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: o , size: l = 24  } = _param, a = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const c = t(), i = o !== null && o !== void 0 ? o : c ? e.colors.inverse : e.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ r("path", {
            fill: i,
            d: "M21.817 8.199V8.19c0-.014 0-.025-.003-.039v-.014l-.009-.05a.236.236 0 00-.005-.024.238.238 0 01-.006-.024.017.017 0 00-.003-.01l-.002-.004a.168.168 0 00-.01-.025l-.004-.011-.006-.012c-.005-.016-.014-.03-.022-.044l-.026-.043-.008-.01a.752.752 0 01-.011-.016l-.007-.01a.214.214 0 00-.004-.006l-.009-.01a.415.415 0 00-.033-.037l-5.463-5.462a.424.424 0 00-.018-.017l-.018-.017-.011-.008-.016-.012-.015-.01-.011-.01-.042-.024c-.007-.005-.015-.008-.023-.012a.223.223 0 01-.022-.01l-.011-.006-.021-.009-.016-.005h-.01c-.015-.006-.032-.009-.048-.012l-.05-.008h-.015l-.02-.001-.02-.002h-.008c-2.193-.002-4.612 0-5.823 0h-.686c-.712 0-1.152.44-1.152 1.149v2.28a5.803 5.803 0 00-2.537 9.168l-3.264 3.386a.562.562 0 00.807.78l3.25-3.376a5.776 5.776 0 001.747.989v4.114c0 .715.443 1.16 1.154 1.16h11.398c.684 0 1.129-.445 1.129-1.132.003-.442.003-8.235.003-12.495zm-1.913-.56h-1.379c-.652 0-1.198-.205-1.582-.589-.384-.384-.586-.933-.586-1.585V4.087L18.13 5.86l1.774 1.778zm-6.533.128a4.68 4.68 0 11-6.62 6.62 4.68 4.68 0 016.62-6.62z"
        })
    }));
}, m = s;
export { m as default };
